/* -------------------------------------------------------------------------- */
/*                            Schema Agents                                   */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const Destination = new schema.Entity('destinations', {}, { idAttribute: 'etaModelId' });
export const Destinations = new schema.Array(Destination);
